(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/receivers-overview.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/receivers-overview.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiversOverview = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.receivers_overview(data);
    },
    className: 'js-grassroots-search-wrapper bg-white grassroots-pop-up',
    events: {
      'click .js-navigate-back': 'navigate'
    },
    templateContext: {
      isCorporateSite: svs.grassroots.data.config.isCorporateSite
    },
    regions: {
      receiverSearch: '#receiverSearch',
      mainViewSearch: '#mainViewSearch',
      myReceivers: '#myReceivers',
      receiverToplists: '#receiverToplists',
      receiverToplistLastPicked: '#lastPicked',
      receiverToplistMostPopular: '#mostPopular',
      receiverToplistMostPopularPoints: '#mostPopularPoints'
    },
    initialize: function() {
      if (this.getOption('add') && this.getOption('name')) {
        svs.ui.loader.show();
        svs.grassroots.collections.grassroots.addSupport(
          parseInt(this.getOption('add'), 10),
          this.getOption('name'),
          this.el
        );
      }
    },
    onAttach: function() {
      var $body = $('body');
      var nav = $('.js-nav');
      var navAndHeaderHeight;
      if (
        (svs.core.detect.breakpoint.current === 'lg' ||
          svs.core.detect.breakpoint.current === 'xl') &&
        $body.hasClass('nav-top')
      ) {
        navAndHeaderHeight = $('#top-content').height() + nav.height();
      } else {
        navAndHeaderHeight = $('#top-content').height();
      }

      $('.js-grassroots-search-wrapper').css(
        'min-height',
        $body.height() - (navAndHeaderHeight + 24)
      );
      $body.scrollTop(0);
      $body.scrollLeft(0);
    },

    onRender: function() {
      if (!svs.grassroots.data.config.isCorporateSite) {
        this.showChildView(
          'myReceivers',
          new svs.grassroots.views.MyReceivers({
            model: svs.grassroots.models.my_receivers,
            collection: svs.grassroots.collections.grassroots
          })
        );
      }
      this.showChildView(
        'receiverSearch',
        new svs.grassroots.views.SearchReceivers()
      );
      this.showChildView(
        'receiverToplists',
        new svs.grassroots.views.ReceiverToplists({
          activeTab: this.getOption('active')
        })
      );
      this.showChildView(
        'receiverToplistLastPicked',
        new svs.grassroots.views.ReceiverToplistsLastPicked({
          collection: svs.grassroots.collections.grassroots
        })
      );
      this.showChildView(
        'receiverToplistMostPopular',
        new svs.grassroots.views.ReceiverToplistsMostPopular({
          model: svs.grassroots.models.grassroots,
          collection: svs.grassroots.collections.grassroots
        })
      );
      this.showChildView(
        'receiverToplistMostPopularPoints',
        new svs.grassroots.views.ReceiverToplistsMostPopularPoints({
          model: svs.grassroots.models.grassroots,
          collection: svs.grassroots.collections.grassroots
        })
      );
    },
    navigate: function(e) {
      if (e.currentTarget && e.currentTarget.getAttribute('data-url')) {
        var url = e.currentTarget
          .getAttribute('data-url')
          .substring(e.currentTarget.getAttribute('data-url').lastIndexOf('/'));
        svs.grassroots.router.navigate(url, {
          trigger: true,
          silent: false,
          replace: false
        });
        return false;
      }
      return true;
    }
  });
})(Backbone, _, svs);


 })(window);